import * as allTypes from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../actionTypes';

/**
 * @typedef {Record<Exclude<import("modules/global/typing/enums/modes.enum").ModeEnum, 'AUDIT'>, Array<string>>} StepsDealerModeIdsReducer
 * @typedef {{[dealerId: string]: StepsDealerModeIdsReducer}} StepsDealerModeReducer
 */

/** @type {StepsDealerModeReducer} */
const initialState = {};

const updateOne = (state, { payload }) => {
  const { dealerId, mode, stepIds } = payload;

  return {
    ...state,
    [dealerId]: {
      ...(state[dealerId] ?? {}),
      [mode]: stepIds
    }
  };
};

const updateAllFromDealer = (state, { payload: dealer }) => {
  const modes = dealer.config?.steps ?? dealer?.configStep ?? {};
  let newState = { ...state };

  Object.entries(modes ?? {}).forEach(([mode, { steps = [] }]) => {
    newState = updateOne(newState, {
      payload: {
        dealerId: dealer.id,
        mode,
        stepIds: steps.map(({ id }) => id)
      }
    });
  });

  return newState;
};

/**
 * @param {*} state
 * @param {import('modules/dealers/types').GenericDealersActionPage} action
 * @returns {*}
 */
const updateAllFromDealers = (state, { payload }) => ({
  ...(payload.content?.reduce((newState, dealer) => updateAllFromDealer(newState, { payload: dealer }), state) ??
    state)
});

/**
 * @param {StepsDealerModeReducer} state
 * @param {import('modules/steps/types/actions').FetchStepsSuccessAction} action
 * @return {StepsDealerModeReducer}
 */
const afterFetchCollection = (state, { payload }) => ({
  ...state,
  [payload.dealerId]: Object.entries(payload.steps).reduce(
    (acc, [mode, steps]) => ({
      ...acc,
      [mode]: steps.map(({ id }) => id)
    }),
    {}
  )
});

const afterUpdateSteps = (state, { payload }) => {
  const { dealerId, mode, steps = [] } = payload;

  return updateOne(state, {
    payload: {
      dealerId,
      mode,
      stepIds: steps.map(({ id: stepId }) => stepId)
    }
  });
};

const afterCreateStep = (state, { payload }) => {
  const { dealerId, mode, step } = payload;
  const existingStepIds = state[dealerId]?.[mode] ?? [];

  return updateOne(state, {
    payload: {
      dealerId,
      mode,
      stepIds: [...existingStepIds, step.id]
    }
  });
};

export default createReducer(initialState, {
  [allTypes.FETCH_DEALER_SUCCESS]: updateAllFromDealer,
  [allTypes.UPDATE_DEALER_SUCCESS]: updateAllFromDealer,
  [allTypes.FETCH_DEALERS_SUCCESS]: updateAllFromDealers,
  [actionTypes.FETCH_STEPS_SUCCESS]: afterFetchCollection,

  [actionTypes.CREATE_STEP_SUCCESS]: afterCreateStep,
  [actionTypes.DELETE_STEP_SUCCESS]: afterUpdateSteps,
  [actionTypes.REORDER_STEPS_SUCCESS]: afterUpdateSteps,
  [actionTypes.PATCH_STEPS_MODE_SUCCESS]: afterUpdateSteps
});
